import React from 'react'
import './Spinner.css'

const Spinner = ({ 
  size = 'medium', 
  className = '',
  ...props 
}) => {
  const classes = [
    'spinner',
    `spinner-${size}`,
    className
  ].filter(Boolean).join(' ')

  return (
    <div className={classes} {...props}>
      <div className="spinner-circle"></div>
    </div>
  )
}

export default Spinner
